import React from "react";

const ToolsBarContext = React.createContext({
    closePanel: () => null,
});

export default ToolsBarContext;
